export const getEmailSubject = (state) => state.emails?.emailSubject

export const getCurrentSelectedDrafts = (state) => state.emails?.selectedDrafts
